import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useTranslate } from 'i18n-calypso';

import OverviewSidebar from 'sections/overview/sidebar';
import Layout from 'components/layout';
import Content from 'components/content';
import ContentHeading from 'components/content/heading';

export default function Error() {
	const translate = useTranslate();
	const error = useRouteError();
	let status = 500;

	if ( isRouteErrorResponse( error ) ) {
		status = error.status;
	}

	return (
		<Layout Sidebar={ OverviewSidebar }>
			<Content>
				<ContentHeading
					/* translators: %d is a numerical error code */
					section={ translate( 'Error %d', { args: [ status ] } ) }
					title={ translate( 'Uh oh. Something went wrong.' ) }
					description={ translate( 'Please reach out to our helpful support team if this happens again.' ) }
				/>
			</Content>
		</Layout>
	);
}
